import { render, staticRenderFns } from "./DownloadDocumentsModalContactTable.vue?vue&type=template&id=5423ffe0&"
import script from "./DownloadDocumentsModalContactTable.vue?vue&type=script&lang=js&"
export * from "./DownloadDocumentsModalContactTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports